import { NgModule } from '@angular/core';

import { SgKcMainRoutingModule } from './sg-kc-main-routing.module';
import { SharedModule } from 'cbc-shared-lib';
import { SgBaseSharedModule } from '../../sg-base/sg-base-shared/sg-base-shared.module';
import { Sgkc021dComponent } from './pages/sgkc021d/pages/sgkc021d/sgkc021d.component';
import { Sgkc021dTankaTableSearchConditionComponent } from './pages/sgkc021d/components/sgkc021d-tanka-table-search-condition/sgkc021d-tanka-table-search-condition.component';
import { Sgkc021dTankaTableSearchResultComponent } from './pages/sgkc021d/components/sgkc021d-tanka-table-search-result/sgkc021d-tanka-table-search-result.component';
import { Sgkc012dComponent } from './pages/sgkc012d/pages/sgkc012d/sgkc012d.component';
import { Sgkc012dTankaTableBasicInfoComponent } from './pages/sgkc012d/components/sgkc012d-tanka-table-basic-info/sgkc012d-tanka-table-basic-info.component';
import { Sgkc012dTankaTableApprovalInfoComponent } from './pages/sgkc012d/components/sgkc012d-tanka-table-approval-info/sgkc012d-tanka-table-approval-info.component';
import { Sgkc012dTankaTableTankaInfoComponent } from './pages/sgkc012d/components/sgkc012d-tanka-table-tanka-info/sgkc012d-tanka-table-tanka-info.component';
import { Sgkc031dComponent } from './pages/sgkc031d/pages/sgkc031d/sgkc031d.component';
import { Sgkc031dSlideTankaSearchConditionComponent } from './pages/sgkc031d/components/sgkc031d-slide-tanka-search-condition/sgkc031d-slide-tanka-search-condition.component';
import { Sgkc031dSlideTankaSearchResultComponent } from './pages/sgkc031d/components/sgkc031d-slide-tanka-search-result/sgkc031d-slide-tanka-search-result.component';
import { Sgkc032dComponent } from './pages/sgkc032d/pages/sgkc032d/sgkc032d.component';
import { Sgkc032dSlideTankaBasicInfoComponent } from './pages/sgkc032d/components/sgkc032d-slide-tanka-basic-info/sgkc032d-slide-tanka-basic-info.component';
import { Sgkc032dSlideTankaApprovalInfoComponent } from './pages/sgkc032d/components/sgkc032d-slide-tanka-approval-info/sgkc032d-slide-tanka-approval-info.component';
import { Sgkc032dSlideTankaTankaInfoComponent } from './pages/sgkc032d/components/sgkc032d-slide-tanka-tanka-info/sgkc032d-slide-tanka-tanka-info.component';
import { Sgkc034dComponent } from './pages/sgkc034d/pages/sgkc034d/sgkc034d.component';
import { Sgkc034dReEnergyTankaResultListComponent } from './pages/sgkc034d/components/sgkc034d-re-energy-tanka-result-list/sgkc034d-re-energy-tanka-result-list.component';
import { Sgkc034dReEnergyTankaApprovalInfoComponent } from './pages/sgkc034d/components/sgkc034d-re-energy-tanka-approval-info/sgkc034d-re-energy-tanka-approval-info.component';
import { Sgkc034dReEnergyTankaInfoComponent } from './pages/sgkc034d/components/sgkc034d-re-energy-tanka-info/sgkc034d-re-energy-tanka-info.component';
import { Sgkc041dComponent } from './pages/sgkc041d/pages/sgkc041d/sgkc041d.component';
import { Sgkc041dReferenceTableSearchConditionComponent } from './pages/sgkc041d/components/sgkc041d-reference-table-search-condition/sgkc041d-reference-table-search-condition.component';
import { Sgkc041dReferenceTableSearchResultComponent } from './pages/sgkc041d/components/sgkc041d-reference-table-search-result/sgkc041d-reference-table-search-result.component';
import { Sgkc041dReferenceTableOutputConditionComponent } from './pages/sgkc041d/components/sgkc041d-reference-table-output-condition/sgkc041d-reference-table-output-condition.component';



@NgModule({
    declarations: [
        Sgkc021dComponent,
        Sgkc021dTankaTableSearchConditionComponent,
        Sgkc021dTankaTableSearchResultComponent,
        Sgkc012dComponent,
        Sgkc012dTankaTableBasicInfoComponent,
        Sgkc012dTankaTableApprovalInfoComponent,
        Sgkc012dTankaTableTankaInfoComponent,
        Sgkc031dComponent,
        Sgkc031dSlideTankaSearchConditionComponent,
        Sgkc031dSlideTankaSearchResultComponent,
        Sgkc032dComponent,
        Sgkc032dSlideTankaBasicInfoComponent,
        Sgkc032dSlideTankaApprovalInfoComponent,
        Sgkc032dSlideTankaTankaInfoComponent,
        Sgkc034dComponent,
        Sgkc034dReEnergyTankaResultListComponent,
        Sgkc034dReEnergyTankaApprovalInfoComponent,
        Sgkc034dReEnergyTankaInfoComponent,
        Sgkc041dComponent,
        Sgkc041dReferenceTableSearchConditionComponent,
        Sgkc041dReferenceTableSearchResultComponent,
        Sgkc041dReferenceTableOutputConditionComponent,
    ],
    imports: [
        SharedModule,
        SgKcMainRoutingModule,
        SgBaseSharedModule,
    ],
    exports: [
    ],
    providers: [
    ]
})
export class SgKcMainModule { }
